import { GridColDef } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import { formatTo0Decimal } from '../../common/util.services';

const ProcessingDataQuantity = (props: any) => {
  const columns: GridColDef[] = [
    { field: 'inputCode', headerName: 'Input Code', filterable: true, sortable: false, editable: false, width: 150 },
    { field: 'description', headerName: 'Description', filterable: false, sortable: false, editable: false, width: 300 },
    { 
      field: 'quantity', headerName: 'Quantity', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params: any) => formatTo0Decimal(params.row.quantity) + ' ' + params.row.uom
    },
    //{ field: 'uom', headerName: 'UOM', filterable: false, sortable: false, editable: false, width: 90 },
  ];

  return <>
    <IGridComponent title={''} rows={props.data} columns={columns} maxHeight={450} hideFooterPagination={true}
      showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
      getRowId={(row: any) => row.inputCode} hideFooter={true}/>
  </>
}

export default ProcessingDataQuantity;